import React from 'react';
import { AlertTriangle } from 'lucide-react';

const FranchiseProblem = () => {
  const challenges = [
    'High frontline turnover',
    'Inconsistent onboarding',
    'Uneven customer experience across locations',
    'Limited manager time for coaching',
    'Rapid expansion without scalable enablement',
    'Communication gaps between corporate and the field',
    'Training drift as systems grow'
  ];

  return (
    <section className="py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-xl text-gray-300 mb-8">
            Franchise and multi-unit organizations face a unique reality:
          </p>
        </div>

        <div className="max-w-3xl mx-auto mb-12">
          <div className="grid md:grid-cols-2 gap-4">
            {challenges.map((challenge, index) => (
              <div
                key={index}
                className="flex items-start gap-4 p-5 rounded-xl bg-gradient-to-br from-red-900/20 to-orange-900/20 border border-red-500/30"
              >
                <AlertTriangle className="w-5 h-5 text-red-400 flex-shrink-0 mt-1" />
                <p className="text-gray-300">{challenge}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="max-w-4xl mx-auto text-center space-y-6">
          <p className="text-lg text-gray-400 italic">
            Traditional LMS platforms and one-time training sessions can't keep pace.
          </p>
          <div className="p-8 rounded-2xl bg-gradient-to-br from-cyan-900/20 to-blue-900/30 border border-cyan-500/30">
            <p className="text-xl text-white font-semibold">
              Traain provides the enablement infrastructure that keeps every location aligned, confident, and on track — no matter how fast you scale.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FranchiseProblem;
